import { render } from "./DateCompanie.vue?vue&type=template&id=78b6c4a9&scoped=true&ts=true"
import script from "./DateCompanie.ts?vue&type=script&lang=ts"
export * from "./DateCompanie.ts?vue&type=script&lang=ts"

import "./DateCompanie.vue?vue&type=style&index=0&id=78b6c4a9&scoped=true&lang=scss"

import exportComponent from "D:\\Melinda\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b6c4a9"]])

export default __exports__